import React, {useState} from 'react';
import {Badge, IconButton, Tooltip} from '@mui/material';
import {useNotifications} from '../../status/StatusContext';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsDropdown from './NotificationsDropdown';
import NotificationSettings from './NotificationSettings';

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function NotificationsButton() {

    const [isNotificationsVisible, setIsNotificationsVisible] = useState(false);
    const [isNotificationSettingsVisible, setIsNotificationSettingsVisible] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const showNotifications = async (e) => {
        setIsNotificationsVisible(true);
        setAnchorEl(e.currentTarget);
    };

    const notificationsCount = useNotifications();

    return (
        <>
            {isNotificationsVisible &&
                <NotificationsDropdown anchorEl={anchorEl} onClose={() => setIsNotificationsVisible(false)}
                                       showNotificationSettings={e => setIsNotificationSettingsVisible(true)}/>}
            {isNotificationSettingsVisible &&
                <NotificationSettings onClose={e => setIsNotificationSettingsVisible(false)}/>}
            <IconButton
                size="large"
                type='button'
                onClick={showNotifications}
                color="inherit"
                style={squareHighlightStyle}
            >
                <Badge badgeContent={notificationsCount} color="error">
                    <Tooltip title='Notifications'>
                        <NotificationsIcon/>
                    </Tooltip>
                </Badge>
            </IconButton>
        </>
    );
}
